export function classnames(...args: string[]) {
  return args.join(' ');
}
